const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
const CHANGE_DIRECTION = "CHANGE_DIRECTION"


const handleChangeLang = (language) => ({
    type: CHANGE_LANGUAGE,
    payload: {
        language
    },
});

const handleChangeDirection = (direction) => ({
    type: CHANGE_DIRECTION,
    payload: {
        direction
    }
});

export {
    CHANGE_LANGUAGE,
    handleChangeLang,
    CHANGE_DIRECTION,
    handleChangeDirection
}
